import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-main hover:text-icon-hover flex h-10 w-8 cursor-pointer items-center justify-end transition-colors duration-150 sm:h-12.5 sm:w-10',
    icon: 'flex size-6 items-center justify-center'
  },
  variants: {
    disabled: {
      true: 'hidden'
    },
    left: {
      true: 'rotate-180 justify-start'
    }
  }
});
